import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Address, InferValuesTypes } from '@yandex-int/k-common/typings';
import { InputChangeEvent } from 'platform-components';

import * as actions from './actions';

export interface FullNameData {
    fullName: string;
    fullNameErrorMessage: string | null;
    handleValidateFullName: (name: string) => void;
    handleFullNameChange: (event: InputChangeEvent) => void;
}

export interface LocalityData {
    locality: Address | null;
    localityErrorMessage: string | null;
    handleValidateLocality: (name: string) => void;
    handleLocalityChange: (localityData: Address | null) => void;
    handleLocalityInputChange: (phrase: string) => void;
    localities: Array<Address>;
}

export interface SchoolData {
    school: string;
    schoolErrorMessage: string | null;
    handleValidateSchool: (name: string) => void;
    handleSchoolChange: (event: InputChangeEvent) => void;
}

export interface EmailData {
    email: string;
    emailErrorMessage: string | null;
    handleValidateEmail: (name: string) => void;
    handleEmailChange: (event: InputChangeEvent) => void;
}

export interface TextData {
    titleId?: string;
    descriptionId?: string;
    formTitleId?: string;
    cancelButtonId?: string;
    acceptButtonId?: string;
}

export interface ImageData {
    src: string;
    srcSet: string;
    mix?: string;
}

export interface CertificateModalStore {
    localities: Array<Address>;
    statusOfGetLocalities: LOADING_STATUSES;
    statusOfAcceptSuggestion: LOADING_STATUSES;
    shownSuggestions: Array<string>;
    statusOfCertificateSection: LOADING_STATUSES;
}

export const CERTIFICATES = 'certificates';
export const CERTIFICATE_SUGGESTIONS = 'certificate_suggestions';

// action types
export type CertificateModalActions = ReturnType<InferValuesTypes<typeof actions>>;
